import React, {useEffect} from "react";
import Grid from "@mui/material/Grid";
import {
    AdmissionAnaesthetist,
    AdmissionConsultant,
    AdmissionSpecialties,
    AdmissionSurgeon,
} from "../../../controls/agyle/dictionaries";
import {Checkbox, FormControl, FormControlLabel, InputLabel, MenuItem, Select} from "@mui/material";
import {admissionViewTypes, SessionsTime} from "../bookedAdmissions";
import TextField from "@mui/material/TextField";
import {useTranslation} from "react-i18next";
import AgyleCalendar from "../content/calendar/AgyleCalendar";
import API from "../../../app/api";
import {useDispatch, useSelector} from "react-redux";
import {TextFieldDebounce} from "../../../controls/agyle/textFieldDebounce";
import AgyleButton from "../../../components/ui/buttons/agyleButton";
import {
    getAdmissionType,
    getConfig,
    getSelectedTheatre,
    getTheatresDict,
    reload,
} from '../../../store/reducers/booked_admissions';
import makeStyles from "@mui/styles/makeStyles";
import AgyleDatePicker from '../../../components/ui/fields/agyleDatePicker';
import AgyleDialog from '../../../components/modal/agyleDialog';
import useOpenState from '../../../hooks/useOpenState';
import WorkstationModal from '../content/modals/workstationModal';
import ObsNumericStepper from '../../ward/forms/observation/components/obsNumericStepper';
import _ from 'lodash';
import config from '../../../app/config';
import clsx from 'clsx';
import moment from 'moment/moment';
import 'moment-timezone';

const useStyles = makeStyles((theme) => ({
    menuPaper: {
        maxHeight: 250,
        background: theme.palette.background.paperDarker
    },
    dayClass: {
        textAlign: "center",
        margin: "5px",
        cursor: "pointer"
    },
    dayOtherSmallMonth: {
        color: "grey",
        pointerEvents: "none"
    },
    selectedDaySmallClass: {
        color: "white",
        borderRadius: "30px",
        pointerEvents: "none",
        backgroundColor: "#E25B61",
        width: "25px",
        textAlign: "center"
    },
    workStationsHeader: {
        display: "flex",
        background: theme.palette.mode === "dark" ? "#313131" : "#e2e2e2",
        justifyContent: "space-between",
        padding: "10px",
        borderRadius: "10px 10px 0 0",
        marginBottom: "3px",
        fontSize: 14
    },
    editButton: {
      cursor: "pointer",
        color: "#2180F7"
    },
    workStationsItem: {
        display: "flex",
        textTransform: "capitalize",
        justifyContent: "space-between",
        background: theme.palette.mode === "dark" ? "#313131" : "#e2e2e2",
        padding: "10px",
        fontSize: 14
    },
    textFieldClass: {
        // backgroundColor: theme.palette.mode === "dark" ? "#252525" : "#ebebeb",
        // border: "1px solid #5f5f5f",
        // borderRadius: 4
    },
    dialogContentStyle: {
        backgroundColor: theme.palette.mode === "dark" ? "#252525" : "#f2f2f2"
    }
}));

export const initNewSession = {
    _day: null,
    day: null,
    specialty: null,
    timeOfDay: null,
    theatre: null,
    consultant: null,
    surgeon: null,
    anaesthetists: null,
    sessionFull: false,
    urgentSlot: 0,
    maxTime: 0,
    message: "",
    autoClose: "",
    bookedSessions: [],
    active: true,
    opType : "TCI",
    locked: false,
    workStations: [],
    status: "PENDING"
}

export const mapTheatreObject = (theatre) => {
    return  {
        description: theatre.description,
        notes: theatre.notes,
        active: theatre.active,
        location: theatre.location,
        locationType: theatre.locationType,
        __id: theatre.__id,
    }
}

const SessionModal = (props) => {

    const {t, i18n} = useTranslation();

    const [sessionData, setSessionData] = React.useState(initNewSession);
    const [sessionValues, setSessionValues] = React.useState([]);
    const [isWorkstationModalOpen, openWorkstationModal, closeWorkstationModal] = useOpenState(false, true);

    const admissionType = useSelector(getAdmissionType);
    const configBA = useSelector(getConfig);
    const theatres = useSelector(getTheatresDict);
    const selectedTheatre = useSelector(getSelectedTheatre);

    const controller = new AbortController();
    const dispatch = useDispatch();
    const classes = useStyles();

    const [selectedDay, setSelectedDay] = React.useState(sessionData.day? moment(sessionData.day).format("DD/MM/YYYY"): null);
    const [selectedHour, setSelectedHour] = React.useState("");

    const [minStartTime, setMinStartTime] = React.useState(null);
    const [lastOperationEndTime, setLastOperationEndTime] = React.useState(null);
    const timezone = config?.defaultTimezone || 'Europe/London';

    const getTheatres = () => {
        return theatres.filter((t) => t.active === true);
    }

    useEffect(()=>{
        if(props.session) {
            setSessionData(props.session);
            setSelectedDay(moment(props.session.day).format("DD/MM/YYYY"));

            let selectedHourTmp = moment(props.session.day).format("HH:mm")

            if(moment.tz(props.session.day, timezone).format("HH:mm") === "00:00")
                selectedHourTmp = configBA?.timeOfDayRanges[props.session.timeOfDay.code].startHour;

            setSelectedHour(selectedHourTmp);

            let startTimeOp = null;
            let lastTimeOp = null;
            let timeOp = 0;

            props.session.bookedSessions.forEach((op) => {
                let s = null;

                if(moment.tz(op.startTime, timezone).format("HH:mm") === "00:00"){
                    timeOp += op.timeLen;
                } else {
                    s = moment(op.startTime);
                }

                let e = s? moment(s).add(op.timeLen, "minutes"): null;

                if(!startTimeOp) startTimeOp = s
                if(startTimeOp >= s) startTimeOp = s;

                if(!lastTimeOp) lastTimeOp = e
                if(lastTimeOp < e) lastTimeOp = e
            })

            if(startTimeOp) setMinStartTime(timeOp> 0? startTimeOp.add(-timeOp, "minutes"): startTimeOp);
            if(lastTimeOp) setLastOperationEndTime(lastTimeOp);

        }
    },[props.session])

    useEffect(()=>{
        if(admissionType === admissionViewTypes.MDU) {

            if(!props.session) {
                let filter = "Medical Day Unit"
                API.getDictByURL(`/admission/person/surgeon?filter=${filter}&pageSize=100&page=1`, controller.signal).then(dictData => {
                    setSessionData((session) => {
                        return {
                            ...session,
                            surgeon: dictData[0],
                        }
                    })
                }).catch(function (error) {
                    console.error("Autocomplete dictionaries error", error);
                });

                filter = "Medical Day Unit"
                API.getDictByURL(`/admission/person/consultant?filter=${filter}&pageSize=100&page=1`, controller.signal).then(dictData => {
                    setSessionData((session) => {
                        return {
                            ...session,
                            consultant: dictData[0],
                        }
                    })
                }).catch(function (error) {
                    console.error("Autocomplete dictionaries error", error);
                });

                filter = "description regex '.*Medical Day Unit.*' and metadata.bookAdmission eq true"

                API.getDictByURL(`/$dict/Specialties?$filter=${filter}`, controller.signal).then(dictData => {
                    //   console.log(dictData);
                    setSessionData((session) => {
                        return {
                            ...session,
                            specialty: dictData.__data[0],
                        }
                    })
                }).catch(function (error) {
                    console.error("Autocomplete dictionaries error", error);
                });

            }

            if(!props.session || !props.session.workStations) {
                let workstationTmp = [];
                let theater = _.find(theatres, {description: selectedTheatre.description, active: true});

                if (config?.mduSessionUseWorkstationDefaults && _.isEmpty(workstationTmp)) {
                    API.getWorkstations(controller.signal).then(data => {
                        if (theater.hasOwnProperty("defaultWorkstations") && Array.isArray(theater.defaultWorkstations)) {
                            let defaultWorkstationEquipmentStuff = {};
                            configBA.workstationEquipmentType.forEach(typeItem => {
                                defaultWorkstationEquipmentStuff[typeItem.code] = data.filter((item) => {
                                    if (item.type === typeItem.code) {
                                        return theater.defaultWorkstations.indexOf(item.id) > -1;
                                    }
                                    return false;
                                });
                            });
                            Object.keys(defaultWorkstationEquipmentStuff).forEach(eqKey => {
                                workstationTmp.push(...defaultWorkstationEquipmentStuff[eqKey]);
                            });
                            setSessionData((session) => {
                                return {
                                    ...session,
                                    workStations: workstationTmp
                                }
                            })
                        }
                    })
                }
                setSessionData((session) => {
                    return {
                        ...session,
                        theatre: theater
                    }
                })
            }

        }
        if(!props.session && selectedTheatre.active) {
            setSessionData((session) => {
                return {
                    ...session,
                    theatre: selectedTheatre
                }
            })
        }
    },[])


    useEffect(()=>{
        if(props.selectedDay) setSelectedDay(props.selectedDay);
    },[props.selectedDay])

    const handleChange = (event, type) => {
        const {name, value} = event.target;

        if(type) {
            setSessionData((formData) => ({
                ...formData,
                [type]: value,
            }));
        } else {
            setSessionData((formData) => ({
                ...formData,
                [name]: value,
            }));
        }

    };


    const setDataDictionary = (data, type) => {
        handleChange({
            target: {
                name: data[0],
                value: data?.[1] || null,
            },
        }, type);
    };

    const renderCustomOption = (opt) => {
        return (
            <MenuItem
                key={opt.__id}
                value={opt}
            >
                {opt.description}
            </MenuItem>
        );
    };


    const selectDayClick = (e) => {
        setSelectedDay(e)
    }

    const onDateChange = (e) => {
        API.getSesions(moment(e).format("YYYY-MM-DD"),
            moment(e).add(31,"days").format("YYYY-MM-DD"), admissionType).then(sessions => {
            setSessionValues(sessions);

        }).catch(function (error) {
            // TODO: error handler !!!
            console.error(error);
        });
    }


    const onSaveAddSession = () => {

        let specialty = _.cloneDeep(sessionData?.specialty);
        delete specialty.metadata;

        let tmp = {
            ...sessionData,
            specialty: specialty,
            day: moment(selectedDay+ " " +selectedHour , "DD/MM/YYYY HH:mm").toISOString(),
            _day: moment(selectedDay+ " " +selectedHour , "DD/MM/YYYY HH:mm").toISOString(),
            theatre: mapTheatreObject(sessionData.theatre),
            opType: admissionType,
            status: "PENDING"
        }

        API.theatreSessionsUpdate(tmp, controller.signal).then(res => {
                dispatch(reload());
            })
            .catch(err => {
                console.error(err);

            })
            .finally(() => {
                // dispatch(setLoading(false));
            });


        props.onClose()
    }

    const countMinTime = () => {
        let timeOpp = 0;
        let t2 = 0;

        if(props.session) {
            let startTimeSession = moment(selectedDay+ " " +selectedHour , "DD/MM/YYYY HH:mm");
            if(lastOperationEndTime) t2 = lastOperationEndTime.diff(startTimeSession, "minutes");

            let times = {};

            props.session.bookedSessions.forEach((item)=> {
                if(!item.holdingPen) {
                    if(!times.hasOwnProperty(item.workStationId)) times[item.workStationId] = 0;
                    times[item.workStationId] += item.timeLen
                }
            })


            Object.keys(times).forEach((key) => {
                if(times[key] > timeOpp) timeOpp = times[key];
            })

            //timeOpp = props.session.bookedSessions.reduce((accumulator, s) => accumulator + s.timeLen, 0);
        }

        return t2 > timeOpp? t2: timeOpp;
    }

    const filterSessions = () => {
        return sessionValues.filter(v => {
            const theatreDescriptionMatch = v.theatre.description === sessionData.theatre?.description;
            const timeOfDayMatch =
                v.timeOfDay.code === sessionData.timeOfDay?.code ||
                (v.timeOfDay.code === "all" && (sessionData.timeOfDay?.code === "am" || sessionData.timeOfDay?.code === "pm")) ||
                (sessionData.timeOfDay?.code === "all" && (v.timeOfDay?.code === "am" || v.timeOfDay?.code === "pm"));

            const isMySession = (sessionData.id && v.id === sessionData.id);

            return theatreDescriptionMatch && timeOfDayMatch && !isMySession;
        });
    };

    const isValid = () => {
        let day = moment(selectedDay+ " " +selectedHour , "DD/MM/YYYY HH:mm");
        return !(!sessionData.timeOfDay || !sessionData.theatre || !selectedDay || sessionData.maxTime < countMinTime() || !sessionData.specialty
            || (minStartTime && day > minStartTime || !(admissionType === admissionViewTypes.THEATRES || sessionData.workStations?.length !== 0)));
    }

    return (
        <>
            <AgyleDialog
                title={"Edit Workstations"}
                open={isWorkstationModalOpen}
                onClose={closeWorkstationModal}
                disableActions
                width={"md"}
                contentStyle={classes.dialogContentStyle}
                closeButtonOnHeader
                fullWidth={true}
            >
                <WorkstationModal
                    onSave={(workstations) => {
                        setSessionData((formData) => ({
                            ...formData,
                            workStations: workstations
                        }));
                        closeWorkstationModal()
                    }}
                    bookedSessions={sessionData.bookedSessions}
                    workstations = {sessionData.workStations || [] }/>
            </AgyleDialog>
            <Grid container spacing={1}>
                <Grid item xs={5}>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <AgyleCalendar onDateChange={onDateChange}
                                           handleOnClick={selectDayClick}
                                           dayClass={classes.dayClass}
                                           selectedDay={selectedDay}
                                           noPadding
                                          // date={sessionData.day || moment()}
                                           dayOtherMonth={classes.dayOtherSmallMonth}
                                           selectedDayClass={classes.selectedDaySmallClass}
                                           values={filterSessions()}/>
                        </Grid>
                        <Grid item xs={12}>
                            <div style={{marginTop: 20}}>
                                <TextFieldDebounce
                                    style={{width: "95%"}}
                                    label={t("Notes")}
                                    onChange={(e) => handleChange(e, "message")}
                                    name="message"
                                    multiline
                                    minRows={5}
                                    maxRows={5}
                                    changeValueTrigger
                                    value={sessionData.message}
                                    variant="outlined"
                                    color="tertiary"
                                />
                            </div>
                        </Grid>
                    </Grid>

                </Grid>
                <Grid item xs={7}>
                    <Grid container spacing={2}>
                        <Grid item xs={9}>
                            <AdmissionSpecialties
                                name="AdmissionSpecialties"
                                label={t("Specialties")}
                                placeholder={t("Type to see more records")}
                                color="primary"
                                value={sessionData.specialty}
                                onChange={(e) => setDataDictionary(["specialty", e])}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl variant="outlined" size={"medium"} style={{width: "100%"}}>
                                <InputLabel>Time Of Day</InputLabel>
                                <Select
                                    name="timeOfDay"
                                    label={"Time Of Day"}
                                    MenuProps={{ classes: { paper: clsx("scroll-normal-white", classes.menuPaper) } }}
                                    value={sessionData?.timeOfDay || ""}
                                    renderValue={(val) => (val.description)}
                                    onChange={(event)=>{
                                        setSessionData((formData) => ({
                                            ...formData,
                                            timeOfDay: event.target.value,
                                            maxTime: configBA.timeOfDayRanges[event.target.value.code].time
                                        }));
                                        setSelectedHour(configBA.timeOfDayRanges[event.target.value.code].startHour)
                                    }}
                                >
                                    {configBA?.timeOfDay.map((time) => (<MenuItem value={time}>{time.description}</MenuItem>))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <AgyleDatePicker
                                label={t("Start Time")}
                                size={"large"}
                                noBorder={false}
                                inputFormat={configBA?.defaultDateFormat}
                                inputVariant="outlined"
                                textFieldClass={classes.textFieldClass}
                                value={moment(selectedHour, "HH:mm")}
                                type="time"
                                maxDate={minStartTime}
                                onChange={(e) => {
                                    if(e) setSelectedHour(e.format("HH:mm"));
                                }}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <FormControl variant="outlined" size={"medium"} style={{width: "100%"}}>
                                <InputLabel>Theatre</InputLabel>
                                <Select
                                    MenuProps={{ classes: { paper: clsx("scroll-normal-white", classes.menuPaper) } }}
                                    name="theatre"
                                    label={"Theatre"}
                                    value={sessionData.theatre || ""}
                                    renderValue={(val) => (val.description)}
                                    onChange={ (event) => {
                                        setSessionData((formData) => ({
                                            ...formData,
                                            theatre: event.target.value
                                        }));
                                    }}
                                >
                                    {getTheatres().map(opt => {return renderCustomOption(opt)})}

                                </Select>
                            </FormControl>
                        </Grid>
                        {admissionType !== admissionViewTypes.THEATRES &&
                        <Grid item xs={12}>
                            <div className={classes.workStationsHeader}>Workstations
                                <div className={classes.editButton} onClick={openWorkstationModal}>edit</div></div>
                            {/*<div >*/}
                            {/*    {Object.keys(typeMap).map((type) => {*/}
                            {/*        return <div className={classes.workStationsItem}>{typeMap[type]}s <div>{sessionData.workStations?.[typeMap[type]]?.length} </div></div>*/}
                            {/*    })*/}
                            {/*    }*/}
                            {/*</div>*/}
                            <div className={classes.workStationsItem}>stations <div>{sessionData.workStations?.length} </div></div>
                        </Grid>
                        }
                        <Grid item xs={12}>
                            <AdmissionConsultant
                                name="AdmissionConsultant"
                                label={"Overseeing Consultant"}
                                color="primary"
                                value={sessionData.consultant}
                                placeholder={t("Type to see more records")}
                                onChange={(e) => setDataDictionary(["consultant", e])}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <AdmissionSurgeon
                                name="AdmissionSurgeon"
                                label={"Surgeon"}
                                color="primary"
                                value={sessionData.surgeon}
                                placeholder={t("Type to see more records")}
                                onChange={(e) => setDataDictionary(["surgeon", e])}
                            />
                        </Grid>
                        {admissionType !== admissionViewTypes.MDU && <Grid item xs={12}>
                            <AdmissionAnaesthetist
                                name="AdmissionAnaesthetist"
                                label={"Anaesthetist"}
                                color="primary"
                                value={sessionData.anaesthetists}
                                placeholder={t("Type to see more records")}
                                onChange={(e) => setDataDictionary(["anaesthetists", e])}
                            />
                        </Grid>
                        }

                        <Grid item xs={12}>
                            {/*<TextField*/}
                            {/*    InputLabelProps={{*/}
                            {/*        shrink: true,*/}
                            {/*    }}*/}
                            {/*    size="normal"*/}
                            {/*    variant="outlined"*/}
                            {/*    className={"custom-dt"}*/}
                            {/*    placeholder={t("Max Time")}*/}
                            {/*    style={{ width: "100%" }}*/}
                            {/*    label={t("Max Time")}*/}
                            {/*    name={"maxTime"}*/}
                            {/*    type={"number"}*/}
                            {/*    max={400}*/}
                            {/*    value={sessionData.maxTime}*/}
                            {/*    onChange={(value)=>{*/}
                            {/*        console.log(value);*/}
                            {/*        setSessionData((formData) => ({*/}
                            {/*            ...formData,*/}
                            {/*            maxTime: value,*/}
                            {/*        }));*/}
                            {/*    }}*/}
                            {/*/>*/}
                            <ObsNumericStepper
                                value={sessionData.maxTime}
                                minValue={countMinTime()}
                                device
                                maxValue={1000}
                                label={t('Max Time (min: ' + countMinTime() +' min)' )}
                                onChange={(value)=>{
                                    setSessionData((formData) => ({
                                        ...formData,
                                        maxTime: value,
                                    }));
                                }}
                            />

                        </Grid>
                        <Grid item xs={6}>
                            <FormControl variant="outlined" size={"medium"} style={{width: "100%"}} >
                                <InputLabel>Urgent Slot</InputLabel>
                                <Select
                                    name="urgentSlot"
                                    label="Urgent Slot"
                                    MenuProps={{ classes: { paper: clsx("scroll-normal-white", classes.menuPaper) } }}
                                    value={sessionData.urgentSlot}
                                    onChange={(e)=>handleChange(e)}
                                >
                                    <MenuItem value={0}>0</MenuItem>
                                    <MenuItem value={1}>1</MenuItem>
                                    <MenuItem value={2}>2</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                size="normal"
                                variant="outlined"
                                className={"custom-dt"}
                                style={{ width: "100%" }}
                                label="Auto Close"
                                name={"autoClose"}
                                value={sessionData.autoClose}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={<Checkbox
                                    checked={sessionData.locked}
                                    onChange={(e)=> {
                                        setSessionData((formData) => ({
                                            ...formData,
                                            locked: e.target.checked
                                        }));}
                                    }
                                    name="locked"/>}
                                label="Lock Session"
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} style={{display: "flex", justifyContent: "flex-end"}}>
                    <AgyleButton
                        onClick={onSaveAddSession}
                        variant="contained"
                        disabled={!isValid()}>
                        Submit
                    </AgyleButton>
                </Grid>
            </Grid>
        </>
        )
}

export default SessionModal